<template>
  <section class="content-section xsmar35" style="background-color: #f7f7f7;">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="section-title text-center">
            <h6>CONTACT FORM</h6>
            <h2>Say Hello</h2>
          </div>
          <!-- end section-title -->
        </div>
        <!-- end col-12 -->
        <div class="col-lg-12">
          <form @submit.prevent="sendMsg">
          <div class="contact-form">
            <div class="col-lg-4 form-group" style="padding: 0px 10px 0px 0px">
              <input type="text" placeholder="Your name" v-model="contact.name" />
            </div>
            <!-- end form-group -->
            <div class="col-lg-4 form-group" style="padding: 0px 10px 0px 0px">
              <input type="text" placeholder="Your e-mail" v-model="contact.email"/>
            </div>
            <div class="col-lg-4 form-group" style="padding: 0px 10px 0px 0px;">
              <input type="text" placeholder="Your phonenumber"  v-model="contact.mobile"/>
            </div>

            <div class="form-group">
              <textarea placeholder="Your message" v-model="contact.msg"></textarea>
            </div>
            <div id="msgWrap" v-html="errMsg"></div>
            <!-- end form-group -->
            <div class="form-group">
              <input type="submit" :value="contact.clicked?'Processing..':'Submit'" :disabled="contact.clicked">
            </div>
            <!-- end form-group -->
          </div>
        </form>
  <div :class="'modal-mask'+(showModal?' show':'')"><div class="modal-wrapper"><div class="modal-container" v-html="modalText"></div></div></div>

          <!-- end contact-form -->
        </div>
        <!-- end col-6 -->
      </div>
      <!-- end row -->
    </div>
    <!-- end container -->
  </section>

  <!-- end content-section -->
  <!-- end content-section -->
</template>

<script>
import axios from "axios";
import { URL } from "@/conf";
export default {
  data:()=>({
      showModal:false,
      errMsg:null,
    modalText:null,
    locationId:localStorage.getItem("locid"),
    myloc:null,
    contact:{clicked:false,name:null,email:null,mobile:null,msg:null}
    }),
    methods:{
  sendMsg(){
this.errMsg="<div class='text-danger'>";
      var valid=true;
      if (!this.contact.name) {
        valid=false;
        this.errMsg+= 'Please enter your Name<br>';
      }
      if (!this.contact.email) {
        valid=false;
        this.errMsg+= 'Please enter your Email ID<br>';
      } else if (!/^[^@]+@\w+(\.\w+)+\w$/.test(this.contact.email)) {
        this.errMsg+= 'Email ID is not valid<br>';
        valid=false;
      }
      if (!this.contact.mobile) {
        valid=false;
        this.errMsg+= 'Contact number cannot be empty<br>';
      }
      if (!this.contact.msg) {
        valid=false;
        this.errMsg+= 'Please enter your Message<br>';
      }
      this.errMsg+="</div>";
      if(valid)
      {        
this.showModal=true;
this.contact.clicked=true;
  this.modalText="<div class='text-danger'>Please wait</div>";
  var that=this;
  axios.post(URL + "contact",this.contact,{headers: {
                'Content-type': 'application/x-www-form-urlencoded',
              }}).then((response) => {
                this.errMsg="";
                this.contact={clicked:false,name:null,email:null,mobile:null,msg:null};
                if(response.data.msg)
               {
                this.modalText=response.data.msg;
               }
               setTimeout(function () {
                 that.showModal=false;
                 that.modalText=null;
               },3000)
              });
            }
      },
    }
};
</script>
